(function () {
  'use strict';

  /* ---------- Wishlist (localStorage) ---------- */
  var KEY = 'rq-wishlist';
  function getWL() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function setWL(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function refreshCount() {
    var n = getWL().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
  }
  function markHearts() {
    var wl = getWL();
    document.querySelectorAll('[data-wishlist]').forEach(function (b) {
      b.classList.toggle('is-active', wl.indexOf(b.getAttribute('data-handle')) > -1);
    });
  }

  /* ---------- Quick view ---------- */
  var qv = document.querySelector('[data-qv]');
  var lastQVTrigger = null;
  function openQV(btn) {
    if (!qv) return;
    lastQVTrigger = btn;
    qv.querySelector('[data-qv-title]').textContent = btn.getAttribute('data-title') || '';
    var img = qv.querySelector('[data-qv-img]');
    var src = btn.getAttribute('data-img');
    if (src) { img.src = src; img.style.display = ''; } else { img.style.display = 'none'; }
    qv.querySelector('[data-qv-price]').textContent = btn.getAttribute('data-price') || '';
    var avail = btn.getAttribute('data-available') === 'true';
    var st = qv.querySelector('[data-qv-status]');
    st.textContent = avail ? 'In stock' : 'Out of stock';
    st.className = 'qv__status stock ' + (avail ? 'stock--in' : 'stock--out');

    var url = btn.getAttribute('data-url') || '#';
    qv.querySelectorAll('[data-qv-link]').forEach(function (a) { a.href = url; });

    // Toggle between the in-stock buy link and the launching-soon notify capture.
    var buy = qv.querySelector('[data-qv-buy]');
    var notify = qv.querySelector('[data-qv-notify]');
    if (buy) buy.hidden = avail ? false : true;
    if (notify) {
      notify.hidden = avail ? true : false;
      if (!avail) {
        var tags = notify.querySelector('[data-qv-tags]');
        if (tags) tags.value = 'notify-me, notify-product:' + (btn.getAttribute('data-handle') || '');
        // Reset the form in case a previous product was already submitted in this session.
        var f = notify.querySelector('form');
        var ok = notify.querySelector('.notify__success');
        if (f) { f.removeAttribute('hidden'); f.reset(); }
        if (ok) ok.setAttribute('hidden', '');
      }
    }

    qv.hidden = false;
    qv.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    // Move focus into the dialog: the waitlist email when shown, else the close button.
    var focusTarget = (!avail && notify) ? notify.querySelector('input[type=email]') : qv.querySelector('[data-qv-close]');
    if (focusTarget) focusTarget.focus();
  }
  function closeQV() {
    if (!qv) return;
    qv.hidden = true;
    qv.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastQVTrigger) { lastQVTrigger.focus(); lastQVTrigger = null; }
  }

  /* ---------- Delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    var w = e.target.closest('[data-wishlist]');
    if (w) {
      e.preventDefault();
      var h = w.getAttribute('data-handle');
      var wl = getWL();
      var i = wl.indexOf(h);
      if (i > -1) { wl.splice(i, 1); } else { wl.push(h); }
      setWL(wl); markHearts(); refreshCount();
      return;
    }
    var q = e.target.closest('[data-quickview]');
    if (q) { e.preventDefault(); openQV(q); return; }
    if (e.target.closest('[data-qv-close]')) { closeQV(); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeQV(); closeWL(); } });

  /* ---------- Wishlist drawer ---------- */
  var wld = document.querySelector('[data-wl]');
  var lastWLTrigger = null;
  function wlMoney(cents) { return '£' + (cents / 100).toFixed(2); }
  function renderWL() {
    if (!wld) return;
    var box = wld.querySelector('[data-wl-items]');
    var empty = wld.querySelector('[data-wl-empty]');
    var wl = getWL();
    box.innerHTML = '';
    if (empty) empty.hidden = wl.length !== 0;
    wl.slice(0, 30).forEach(function (h) {
      fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || wld.hidden) return;
          var row = document.createElement('div');
          row.className = 'wld__item';
          var thumb = document.createElement('a');
          thumb.className = 'wld__thumb'; thumb.href = p.url; thumb.tabIndex = -1; thumb.setAttribute('aria-hidden', 'true');
          if (p.featured_image) {
            var im = document.createElement('img');
            im.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=120';
            im.alt = ''; im.loading = 'lazy'; im.width = 56; im.height = 70;
            thumb.appendChild(im);
          }
          var info = document.createElement('div');
          info.className = 'wld__info';
          var a = document.createElement('a');
          a.className = 'wld__title'; a.href = p.url; a.textContent = p.title;
          var pr = document.createElement('p');
          pr.className = p.available ? 'wld__price' : 'wld__price wld__oos';
          pr.textContent = p.available ? wlMoney(p.price) : 'Out of stock';
          info.appendChild(a); info.appendChild(pr);
          var rm = document.createElement('button');
          rm.type = 'button'; rm.className = 'wld__remove';
          rm.setAttribute('data-wl-remove', ''); rm.setAttribute('data-handle', h);
          rm.setAttribute('aria-label', 'Remove ' + p.title + ' from wishlist');
          rm.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>';
          row.appendChild(thumb); row.appendChild(info); row.appendChild(rm);
          box.appendChild(row);
        });
    });
  }
  function openWL() {
    if (!wld) return;
    wld.hidden = false;
    wld.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    renderWL();
    var c = wld.querySelector('button[data-wl-close]');
    if (c) c.focus();
  }
  function closeWL() {
    if (!wld || wld.hidden) return;
    wld.hidden = true;
    wld.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastWLTrigger) { lastWLTrigger.focus(); lastWLTrigger = null; }
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-wishlist-open]');
    if (o) { e.preventDefault(); lastWLTrigger = o; openWL(); return; }
    if (e.target.closest('[data-wl-close]')) { closeWL(); return; }
    var rm = e.target.closest('[data-wl-remove]');
    if (rm) {
      var h = rm.getAttribute('data-handle');
      var wl = getWL();
      var i = wl.indexOf(h);
      if (i > -1) { wl.splice(i, 1); setWL(wl); }
      refreshCount(); markHearts(); renderWL();
    }
  });

  /* ---------- Notify-me capture (PDP, quick view, hero waitlist) ---------- */
  /* Posts the customer form to /contact (tags: notify-me + notify-product:<handle>
     or notify-me, waitlist) without leaving the page, then swaps in the success note. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-notify] form');
    if (!form) return;
    e.preventDefault();
    var box = form.closest('[data-notify]');
    var ok = box.querySelector('.notify__success');
    var btn = form.querySelector('button[type=submit]');
    var label = btn ? btn.textContent : '';
    function restore() { if (btn) { btn.disabled = false; btn.textContent = label || 'Notify me'; } }
    if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
    // Shopify /contact returns a 302 to ?contact_posted=true on success (fetch follows it),
    // so treat ok/redirected as success and re-enable the button on a real failure.
    fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (res) {
        if (res.ok || res.redirected) { form.setAttribute('hidden', ''); if (ok) ok.removeAttribute('hidden'); }
        else { restore(); }
      })
      .catch(restore);
  });

  /* ---------- Faceted filters ---------- */
  /* Desktop: checkbox facets auto-apply. Mobile (≤990px, the drawer breakpoint):
     no auto-apply — the reload would snap the CSS-toggle drawer shut — use the
     Apply button. Price applies via its Go button / Enter. */
  function submitFilterForm(form) {
    if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
  }
  var facetsForm = document.querySelector('[data-facets-form]');
  if (facetsForm) {
    facetsForm.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="checkbox"]')) return;
      if (window.matchMedia('(max-width: 990px)').matches) return;
      submitFilterForm(facetsForm);
    });
  }
  var sortSel = document.getElementById('SortBy');
  if (sortSel) {
    /* sortSel.form is the facets form (via form= attribute) or the standalone sort form. */
    sortSel.addEventListener('change', function () { if (sortSel.form) submitFilterForm(sortSel.form); });
  }

  /* ---------- Quantity steppers (cart + product page) ---------- */
  /* +/− adjusts the input within its min/max. Inside the cart form the change
     also submits the form (requestSubmit with no submitter never includes the
     checkout button's name, so a qty change can only update the cart). On the
     product page it just changes the value. */
  function stepQty(btn) {
    var input = btn.parentElement.querySelector('.qty__input');
    if (!input) return null;
    var v = parseInt(input.value, 10);
    if (isNaN(v)) v = 1;
    v += btn.hasAttribute('data-qty-plus') ? 1 : -1;
    var min = input.hasAttribute('min') ? parseInt(input.getAttribute('min'), 10) : 0;
    if (v < min) v = min;
    if (input.hasAttribute('max')) {
      var max = parseInt(input.getAttribute('max'), 10);
      if (!isNaN(max) && v > max) v = max;
    }
    input.value = v;
    return input;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    var input = stepQty(btn);
    if (!input) return;
    var cart = btn.closest('[data-cart-form]');
    if (cart) submitFilterForm(cart);
  });
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    cartForm.addEventListener('change', function (e) {
      if (e.target.matches('.qty__input')) submitFilterForm(cartForm);
    });
  }

  /* ---------- Dispatch cutoff countdown (PDP, opt-in) ---------- */
  /* Counts down to the next configured cutoff (data-time "14:00",
     data-days "1,2,3,4,5" where 1=Mon…7=Sun). When today isn't a dispatch
     day or the cutoff has passed, it shows the static "Order by …" line
     instead of a countdown — no false urgency. */
  var cutoff = document.querySelector('[data-cutoff]');
  if (cutoff) {
    var coLabel = cutoff.querySelector('[data-cutoff-label]');
    var coParts = (cutoff.getAttribute('data-time') || '14:00').split(':');
    var coH = parseInt(coParts[0], 10), coM = parseInt(coParts[1], 10) || 0;
    var coDays = (cutoff.getAttribute('data-days') || '1,2,3,4,5').split(',').map(function (d) { return parseInt(d, 10) % 7; }); // 1=Mon…7=Sun → JS 1…6,0
    var coText = cutoff.getAttribute('data-text') || '';
    function coTick() {
      if (!coLabel || isNaN(coH)) return;
      var now = new Date();
      var target = new Date(now.getFullYear(), now.getMonth(), now.getDate(), coH, coM, 0, 0);
      if (coDays.indexOf(now.getDay()) > -1 && target > now) {
        var mins = Math.floor((target - now) / 60000);
        var h = Math.floor(mins / 60), m = mins % 60;
        coLabel.textContent = 'Order in the next ' + (h > 0 ? h + 'h ' : '') + m + 'm ' + coText;
      } else {
        coLabel.textContent = 'Order by ' + (cutoff.getAttribute('data-time') || '') + ' ' + coText;
      }
    }
    coTick();
    setInterval(coTick, 30000);
  }

  /* ---------- Sticky header condense ---------- */
  /* The header is sticky in CSS; this only toggles the condensed state and
     publishes the live header height as --stuck-h so the facet sidebar and
     PDP gallery can offset themselves instead of sliding under it.
     Hysteresis stops the header flickering when a scroll lands on a threshold. */
  var siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    var stuck = false;
    function syncHeaderHeight() {
      document.documentElement.style.setProperty('--stuck-h', siteHeader.offsetHeight + 'px');
    }

    /* The two informational strips collapse by animating height. The expanded
       height has to be a real pixel value for the transition to have anything
       to run between, and it must be written inline (a stylesheet rule could
       not override an inline height). Measured here rather than hard-coded so
       it survives copy changes and text wrapping at any width. */
    var strips = [].slice.call(siteHeader.querySelectorAll('.util-bar, .announcement-bar'));
    var stripHeights = [];
    function measureStrips() {
      strips.forEach(function (el, i) {
        var t = el.style.transition;
        el.style.transition = 'none';       /* never animate the measurement itself */
        el.style.height = 'auto';
        stripHeights[i] = el.offsetHeight;
        el.style.height = (stuck ? 0 : stripHeights[i]) + 'px';
        void el.offsetHeight;               /* flush before restoring the transition */
        el.style.transition = t;
      });
    }
    function applyStrips() {
      strips.forEach(function (el, i) {
        el.style.height = (stuck ? 0 : stripHeights[i]) + 'px';
      });
    }
    measureStrips();
    /* Runs directly on scroll rather than inside requestAnimationFrame: the work
       is a threshold compare that only touches the DOM when the state actually
       flips, and rAF is throttled to nothing in background/hidden tabs. */
    /* The GAP between these two thresholds MUST EXCEED the header's own height
       change (~77px). Changing the header's height changes the document height,
       and the browser's scroll anchoring compensates by moving scrollY by
       roughly that same amount. With the old 20/60 pair the gap was only 40px,
       so the reflow the header caused was itself enough to cross the opposite
       threshold and flip it straight back — measured at 26 flips per second,
       settling only at scrollY 0 because scroll cannot go negative. */
    var EXPAND_BELOW = 40;
    var CONDENSE_ABOVE = 160;
    /* Second guard: ignore scroll events for slightly longer than the
       transition, so the reflow we just caused is never read as user intent. */
    var SETTLE_MS = 260;
    var lastFlip = 0;
    var recheck = null;
    function onHeaderScroll() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var now = Date.now();
      if (now - lastFlip < SETTLE_MS) {
        /* Re-evaluate once the window closes. Without this trailing check the
           last scroll before the user stops can be swallowed, stranding the
           header in the wrong state (e.g. condensed while sitting at the top),
           because no further scroll events arrive to correct it. */
        if (!recheck) {
          recheck = setTimeout(function () {
            recheck = null;
            onHeaderScroll();
          }, SETTLE_MS - (now - lastFlip) + 20);
        }
        return;
      }
      if (!stuck && y > CONDENSE_ABOVE) {
        stuck = true;
        lastFlip = now;
        siteHeader.classList.add('is-stuck');
        applyStrips();
        syncHeaderHeight();
      } else if (stuck && y < EXPAND_BELOW) {
        stuck = false;
        lastFlip = now;
        siteHeader.classList.remove('is-stuck');
        applyStrips();
        syncHeaderHeight();
      }
    }
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
    /* --stuck-h must land on the FINAL height, so re-sync when the animation
       ends as well as when it starts. */
    siteHeader.addEventListener('transitionend', function (e) {
      if (e.propertyName === 'min-height' || e.propertyName === 'height') syncHeaderHeight();
    });
    window.addEventListener('resize', function () {
      measureStrips();
      syncHeaderHeight();
    });
    syncHeaderHeight();
    onHeaderScroll();
  }

  /* ---------- Account: address forms ---------- */
  /* all_country_option_tags gives each <option> a data-provinces JSON array.
     On country change (and once on load, honouring data-default), populate the
     province select and hide its wrapper when the country has no provinces. */
  function wireAddressForm(form) {
    var country = form.querySelector('[data-country-select]');
    if (!country) return;
    var provWrap = form.querySelector('[data-province-wrap]');
    var prov = form.querySelector('[data-province-select]');
    var defCountry = country.getAttribute('data-default');
    if (defCountry) {
      for (var i = 0; i < country.options.length; i++) {
        if (country.options[i].value === defCountry || country.options[i].text === defCountry) {
          country.selectedIndex = i;
          break;
        }
      }
    }
    function update(initial) {
      if (!prov || !provWrap) return;
      var opt = country.options[country.selectedIndex];
      var provinces = [];
      try { provinces = JSON.parse(opt ? opt.getAttribute('data-provinces') : null) || []; } catch (e) {}
      prov.innerHTML = '';
      if (!provinces.length) { provWrap.hidden = true; return; }
      provWrap.hidden = false;
      var defProv = initial ? prov.getAttribute('data-default') : null;
      provinces.forEach(function (p) {
        var o = document.createElement('option');
        o.value = p[0];
        o.textContent = p[1];
        if (defProv && (p[0] === defProv || p[1] === defProv)) o.selected = true;
        prov.appendChild(o);
      });
    }
    update(true);
    country.addEventListener('change', function () { update(false); });
  }
  document.querySelectorAll('[data-address-form]').forEach(wireAddressForm);

  /* Confirm guard (address delete) */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-confirm]');
    if (f && !window.confirm(f.getAttribute('data-confirm'))) e.preventDefault();
  });

  /* ---------- Carousels ---------- */
  document.querySelectorAll('[data-carousel]').forEach(function (c) {
    var track = c.querySelector('[data-carousel-track]');
    if (!track) return;
    function step() { return Math.max(240, track.clientWidth * 0.8); }
    var prev = c.querySelector('[data-carousel-prev]');
    var next = c.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  /* ---------- Trustpilot TrustBox re-init ---------- */
  /* The TrustBox markup in the footer is Trustpilot's snippet verbatim and must
     stay that way. The theme editor re-renders a section's DOM without a page
     reload, which leaves the bare fallback <a> where the widget was; this is
     Trustpilot's own documented way to re-mount it. Editor-only — the event
     never fires on the live storefront. */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.trustpilot-widget');
    if (el && window.Trustpilot) window.Trustpilot.loadFromElement(el, true);
  });

  refreshCount();
  markHearts();
})();
